"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2022 BLUECROSS BLUESHIELD OF SOUTH CAROLINA ALL RIGHTS RESERVED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGGING_IS_DISABLED_MESSAGE = exports.IGNORE_EVENT_LOGGING_URLS = exports.MESSAGE_GOOGLE_ANALYTICS_TYPE = exports.MESSAGE_ANALYTICS_TYPE = exports.MESSAGE_NETWORK_TYPE = exports.VENDOR_UUID_HEADER = exports.EVENT_LOG_URL = void 0;
/**
 * Constants used in the Utilities module.
 * Some of these constant definitions should be externalized once we deploy to OpenShift.
 **/
/** the base url for the Event Log service */
const BASE_EVENT_LOG_URL = 'commservices-eventlog/api';
/** the Event Log url */
exports.EVENT_LOG_URL = BASE_EVENT_LOG_URL + '/v1/event/';
/** Middle tier response header sometimes contains the middle tier transaction id */
exports.VENDOR_UUID_HEADER = 'x-global-transaction-id';
/** Define a logging payload as type <code>network</code> */
exports.MESSAGE_NETWORK_TYPE = 'network';
/** Define a logging payload as type <code>analytics</code> */
exports.MESSAGE_ANALYTICS_TYPE = 'analytics';
/** Define a logging payload analytics type as <code>google_analytics</code> */
exports.MESSAGE_GOOGLE_ANALYTICS_TYPE = 'google_analytics';
/** Define a list of URLs that should not be logged */
exports.IGNORE_EVENT_LOGGING_URLS = [BASE_EVENT_LOG_URL];
/** Logging is disabled messge */
exports.LOGGING_IS_DISABLED_MESSAGE = 'logging is disabled';
//# sourceMappingURL=app-constants.js.map